import { Typography } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';

export interface IERSDisclaimerProps {
  textVariant?: string;
}

export const HomePageDisclaimer = ({ textVariant }: IERSDisclaimerProps) => {
  const [memberDetails] = useGlobalState('memberDetails');
  const { clubCode } = memberDetails;

  return (
    <Typography
      className="homepage-disclaimer-ca"
      variant={(textVariant as any) ?? 'b2Regular'}
      sx={{ color: '#404040', marginTop: '2rem' }}
    >
      Extended Roadside Assistance services for AAA Plus
      <sup>®</sup>, AAA Plus<sup>®</sup> RV, AAA Premier
      <sup>®</sup>, or AAA Premier<sup>®</sup> RV benefit levels, where available, along with other selected benefits,
      are effective seven (7) calendar days after processing and receipt of the full payment due.
    </Typography>
  );
};
